import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { ApplicationListParams } from '../model/application-list-params';
import * as applicationList from '../actions/application-list.actions';
import { AppsRestClient } from '../services/apps-rest-client.service';
import { selectEnabledApplicationParams } from '../application.selector';
import { Store } from '@ngrx/store';
import { ApplicationsState } from '../applications.state';

import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/withLatestFrom';


@Injectable()
export class ApplicationListEffects {

    /**
     * Side effect to trigger application list fetch as a result of change paging event.
     */
    @Effect() changeParams$ = this.actions$
        .ofType(applicationList.CHANGE_PARAMS)
        .map(() => new applicationList.LoadRequestAction());

    /**
     * Side effect to load application list / page as a result of change paging event.
     */
    @Effect() loadRequest$ = this.actions$
        .ofType(applicationList.LOAD_REQUEST)
        .withLatestFrom(this.store.select(selectEnabledApplicationParams))
        .map(([, params]: ([applicationList.LoadRequestAction, ApplicationListParams])) => params)
        .switchMap((params: ApplicationListParams) => this.loadApplications(params));

    /**
     * Function to load application list.
     * @param {ApplicationListParams} params
     */
    private loadApplications = (params: ApplicationListParams) => this.client.loadEnabledApplicationList(params)
        .map(payload => (new applicationList.LoadSuccessAction(payload)))
        // If request fails, dispatch failed action
        .catch(error => Observable.of(new applicationList.LoadErrorAction(error)));

    constructor(private store: Store<ApplicationsState>,
                private client: AppsRestClient,
                private actions$: Actions) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/applications/effects/application-list.effects.ts